import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/42_card_back_eiffel_tower/42_card_back_eiffel_tower"
 * Contains 1 texture(s)
 */
export class CardsBacks42CardBackEiffelTowerAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/42_card_back_eiffel_tower/42_card_back_eiffel_tower';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '42_eiffel_tower.png'
    ] as const;
}
